import { render } from "./SupportFaq.vue?vue&type=template&id=39a7b9aa&scoped=true"
import script from "./SupportFaq.vue?vue&type=script&lang=js"
export * from "./SupportFaq.vue?vue&type=script&lang=js"

import "./SupportFaq.vue?vue&type=style&index=0&id=39a7b9aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a7b9aa"]])

export default __exports__